import { useSelector } from "react-redux";

export default function useFeature(name) {
    const user = useSelector(state => state.user);

    // Note: Currently the route and name must be in sync... otherwise
    // we would have to parse out route in the options
    const feature = user.roleFeatures.find(f => f.name.toLowerCase().trim() === name.toLowerCase().trim());

    // Mock up DS
    if (!feature) {
        if (name.toLowerCase().indexOf('ignore') < 0) {
            // TODO: Uncomment once bug in data loader metric cards updated
            // console.log("**WARN** Feature '{0}' was not found or configured".format(name));
        }
    }

    return feature;
}
